import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Flex, Select, Button } from "@mantine/core";
import { getUserList } from "pages/Admin/User/apis/adminUserApis";
import { getGroupList } from "pages/Admin/Group/apis/adminGroupApis";
import SRD_DataTable from "components/DataTable";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";
import { useQuery } from "react-query";
import { PAGE_SIZE } from "CommonData";

function UserDataTable() {
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);
  const loginGroupId = adminLevel ? null : user?.fn_group_id;
  const [data, setData] = useState([]);
  const adminOption = {value : null, label : "전체 그룹"};
  const [searchParams, setsearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;

  const setPage = (newPage) => {
    const next = new URLSearchParams(searchParams);
    if (newPage){
      next.set("page", String(newPage));
    }
    else {
      next.set("page", "1");
    }
    setsearchParams(next);
  };

  const group = searchParams.get("group") ?? loginGroupId

  const setGroup = (newGroup) => {
    const next = new URLSearchParams(searchParams);
    if (newGroup) {
      next.set("group", newGroup);
    } else {
      next.delete("group");
    }
    next.set("page", "1");
    setsearchParams(next);
  };

  const { data: groupList } = useQuery(
    "groupList",
    () =>
      getGroupList(1000, 1).then((res) => 
        res.map((item) => ({ value: item.group_id, label: item.group_nm }))
      ),
    {
      staleTime: 5 * 60 * 1000, // 5분
    }
  );
  useEffect(() => {
    getUserList(PAGE_SIZE, page,group)
    .then(res => setData(res));
  }, [group,page]);

  const selectOverallGroup = () => {
    if (!adminLevel || groupList?.length < 1) return;
    const grList = groupList?.map((record) => record.label);
    if( !grList?.includes("전체 그룹") ){
      groupList?.splice(0,0,adminOption);
    } 
  }
  selectOverallGroup();


  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "user_id",
      title: "ID",
      cellsStyle: {
        color: "blue",
 //       textDecoration: "underline",
      },
      onClick: function (e) {
        navigate(`/admin/user/${e.record.user_id}`, {state: {pg: page, group}});
      },
    },
    {
      accessor: "fn_name",
      title: "이름",
    },
    {
      accessor: "fn_level_nm",
      title: "사용자레벨",
    },
    {
      accessor: "fn_group_nm",
      title: "소속그룹",
    },
    /*
    {
      accessor: "filed_nm",
      title: "소속현장",
    },
    */
    {
      accessor: "fn_mobile_nbr",
      title: "전화번호",
    },
    {
      accessor: "fn_address",
      title: "주소",
    },
    {
      accessor: "fn_reg_date",
      title: "등록일",
    },
  ];

  const RegisterButton = () => {
    return (
      <Button variant="default" onClick={() => navigate("/admin/user/add", {state: {pg: page, group}})}>
        등록관리
      </Button>
    );
  };

  const SearchBar = () => {
    const handleGroupChange = (value) => setGroup(value);
  
    return (
      <Flex gap={15} mb={10} align="center" style={{ width: "100%" }}>
        <Select
          data={groupList ?? []}
          value={group}
          placeholder="그룹선택"
          onChange={handleGroupChange}
          style={{
            flex: 1,
          }}
        />
       <RegisterButton /> 
      </Flex>
    );
  };

  return (
    <div style={{ width: "100%", height: "900px"}}>
      <SRD_DataTable 
        searchBar={<SearchBar />}
        data={data} 
        columns={columns} 
        page={page} 
        setPage={setPage} 
      />
    </div>
  );
}

export default UserDataTable;
